import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, catchError, map, throwError} from 'rxjs';
import {AppConfigurationService} from '../../base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
  ) {}
  // Tela - Produtos
  getEnums(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Product/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  // Tela - Campanha
  getTypeCampaignEnum(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Campaign/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  // Tela - Contratos
  getEnumsContract(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Contract/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  // Tela - Regra de Notificação
  getEnumsNotifications(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/ContractNotification/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  //Tela - Regra de Elegibilidade
  getEnumsElegibilidade(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/EligibilityRules/GetEnumsElegibilityRule`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //Tela - Coberturas Adicionais
  getEnumsGrauParentescoCoberturasAdcionais(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/AdditionalCoverages/ListDocumentsByParentalRelationship`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //Tela - Produtos / Entidade
  getEnumsProdutoEntidade(): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/BranchCompanyContractProduct/GetEnums`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //Tela - Arquivos e Observações
  getEnumsArquivosEObservacoes(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/ContractObservation/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
  //Tela - Cotacao
  listarOperadoraPorTipoProduto(tipoProdutoId: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListOperatorsByProductType?productType=${tipoProdutoId}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //contractModalityProduct=${tipoContratacao}&productType=${tipoProdutoId}&operatorId=${operadoraId}`
  filtroEntidades(
    tipoContratacao: any | undefined,
    tipoProdutoId: any,
    operadoraId: string,
    profissaoId?: string,
  ): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/AllLists/ListBranchsCompaniesContracts?contractModalityProduct=${tipoContratacao}&productType=${tipoProdutoId}&operatorId=${operadoraId}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }
  //Tela - Proposta
  getEnumsProposta(): Observable<any> {
    return this.httpClient.get<any>(`${this.appConfigurationService.apiBaseUrl}/Proposal/GetEnums`).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }
}
